import classNames from 'clsx';
import React from 'react';
import Slider from 'react-slick';
import type { Settings } from 'react-slick';

import styles from './CMSCarousel.scss';

interface Props {
  slideSpeed: number;
  animationSpeed?: number;
  arrows?: boolean;
  asNavFor?: Slider;
  autoRotate?: boolean;
  className?: string;
  dots?: boolean;
  focusOnSelect?: boolean;
  infinite?: boolean;
  onSwipe?: Settings['onSwipe'];
  responsive?: Settings['responsive'];
  sliderRef?: (slider: Slider) => void;
  slidesToShow?: number;
  variableWidth?: boolean;
  wrapperClassName?: string;
  withHeading?: boolean;
}

const Arrow = ({
  onClick,
  type
}: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type: 'prev' | 'next';
}) => (
  <button type="button" className={classNames(styles.arrow, styles[`${type}`])} onClick={onClick}>
    <span className={styles[`${type}Arrow`]} />
  </button>
);

const CarouselSlider: React.FC<React.PropsWithChildren<Props>> = ({
  slideSpeed,
  animationSpeed = slideSpeed || 500,
  arrows = true,
  asNavFor,
  autoRotate,
  children,
  className,
  dots = true,
  focusOnSelect,
  infinite = true,
  onSwipe,
  responsive,
  sliderRef,
  slidesToShow = 3,
  variableWidth = true,
  wrapperClassName,
  withHeading
}) => (
  <div
    className={classNames(styles.cmsCarousel, wrapperClassName, {
      [styles.withHeading]: withHeading
    })}
  >
    <Slider
      adaptiveHeight
      arrows={arrows}
      asNavFor={asNavFor}
      autoplay={autoRotate}
      autoplaySpeed={slideSpeed}
      centerMode
      centerPadding="0"
      className={className}
      dots={dots}
      focusOnSelect={focusOnSelect}
      infinite={infinite}
      nextArrow={<Arrow type="next" />}
      onSwipe={onSwipe}
      prevArrow={<Arrow type="prev" />}
      ref={sliderRef}
      responsive={responsive}
      slidesToShow={slidesToShow}
      speed={animationSpeed}
      variableWidth={variableWidth}
    >
      {children}
    </Slider>
  </div>
);

export default CarouselSlider;
